export default function applyCustomization() {

    ko.observableArray.fn.swap = function (index1, index2) {
        this.valueWillMutate();

        let temp = this()[index1];
        this()[index1] = this()[index2];
        this()[index2] = temp;

        this.valueHasMutated();
    };
};